'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import { styled } from '@acko-tech/building-blocks.ui.common'

export const ItemsListingWrapper = styled.div`
  background: #fff;
  padding: 0 120px 20px 120px;
  color: #414a53;
  @media (max-width: 700px) {
    padding: 0;
  }
`

export const ItemListingContentWrapper = styled.div.attrs((props: { isMobile: boolean }) => props)`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-areas: 'left right';
  grid-gap: 30px;

  @media (max-width: 700px) {
    display: block;
  }

  ${({ isMobile }) =>
    isMobile &&
    `
      @media (max-width: 1140px) {
      display: block;
      }
    `}
`

export const ItemListingLeftContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
  @media (max-width: 700px) {
    display: block;
  }
`

export const Divider = styled.hr`
  margin-top: 20px;
  margin-bottom: 20px;
`

export const RightContainer = styled.div``
export const RightStickyContainer = styled.div<{ isMobile: boolean }>`
  ${({ isMobile }) =>
    !isMobile &&
    `position: sticky;
  top: 72px;
  margin-bottom: 15px;`}
`

export const RecentItemsContainer = styled.div<{ isMobile: boolean }>`
  margin-top: ${({ isMobile }) => (!isMobile ? '1rem;' : '-21px')};
`

export const CategoryList = styled.div`
  margin-top: 30px;
`

export const CallbackWidgetExplore = styled.div``
